<div class="container">
  <div class="col-md-12">
    <!-- Header -->
    <div class="location-header">
      <div class="location-header-content">
        <div class="location-info-section">
          <h2 class="location-name">{{ location.name || "New Location" }}</h2>
          <div class="location-basic-info">
            <div class="info-item">
              <strong>City:</strong>
              {{ location.city || "N/A" }}
            </div>
            <div class="info-item">
              <strong>State:</strong>
              {{ location.stateAbbreviation || "N/A" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex" style="justify-content: space-between; align-items: center">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" [class.active]="selectedTab === 'details'">
          <a class="nav-link" (click)="onTabClicked('details')">DETAILS</a>
        </li>
        <li class="nav-item" [class.active]="selectedTab === 'qualifications'">
          <a class="nav-link" (click)="onTabClicked('qualifications')">QUALIFICATIONS</a>
        </li>
        <li class="nav-item" [class.active]="selectedTab === 'schedule'">
          <a class="nav-link" (click)="onTabClicked('schedule')">SCHEDULE</a>
        </li>
        <li class="nav-item" [class.active]="selectedTab === 'files'">
          <a class="nav-link" (click)="onTabClicked('files')">FILES</a>
        </li>
        <li class="nav-item" [class.active]="selectedTab === 'notes'">
          <a class="nav-link" (click)="onTabClicked('notes')">NOTES</a>
        </li>
      </ul>
    </div>

    <div class="tab-content white-bg-tabs">
      <div *ngIf="selectedTab === 'details'">
        <app-location-details-tab
          [location]="location"
          [isEditMode]="isEditMode"
          [countries]="countries"
          [states]="states"
          (hasChanges)="onTabHasChanges($event)"
          (countryChange)="onCountryChange()"
          (fieldChange)="updateLocationId()"
        ></app-location-details-tab>
      </div>
      <div *ngIf="selectedTab === 'qualifications'">
        <app-location-qualifications-tab
          [location]="location"
          [isEditMode]="isEditMode"
          [productQualificationsList]="productQualifications"
          [loadingProductQualifications]="loadingProductQualifications"
          (hasChanges)="onTabHasChanges($event)"
        ></app-location-qualifications-tab>
      </div>
      <div *ngIf="selectedTab === 'schedule'">
        <app-location-schedule-tab
          [location]="location"
          [isEditMode]="isEditMode"
          (hasChanges)="onTabHasChanges($event)"
        ></app-location-schedule-tab>
      </div>
      <div *ngIf="selectedTab === 'files'">
        <app-location-files-tab
          [location]="location"
          [isEditMode]="isEditMode"
          (hasChanges)="onTabHasChanges($event)"
        ></app-location-files-tab>
      </div>
      <div *ngIf="selectedTab === 'notes'">
        <app-location-notes-tab
          [location]="location"
          [isEditMode]="isEditMode"
          (hasChanges)="onTabHasChanges($event)"
        ></app-location-notes-tab>
      </div>
    </div>

    <!-- Footer -->
    <div class="location-footer">
      <div class="footer-left"></div>
      <div class="footer-right">
        <button
          *ngIf="isEditMode"
          type="button"
          class="btn btn-secondary"
          (click)="cancelEdit()"
          [disabled]="isProcessing"
        >
          Cancel
        </button>
        <button
          *ngIf="!isNewLocation && hasPermission('LocationsChange')"
          type="button"
          class="btn btn-primary"
          (click)="toggleEditMode()"
          [disabled]="isProcessing"
        >
          {{ isEditMode ? "Save Changes" : "Edit Location" }}
        </button>
        <button
          *ngIf="isNewLocation"
          type="button"
          class="btn btn-primary"
          (click)="saveLocation()"
          [disabled]="isProcessing"
        >
          Create Location
        </button>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="Select Near Location"
  [(visible)]="exactLocationsData.length"
  [style]="{ 'max-width': '1600px' }"
>
  <h4>Please select one of the available options.</h4>
  <app-pc-miller-near-locations
    [locations]="exactLocationsData"
    (locationSelected)="finishLocationCreateUpdate($event)"
  ></app-pc-miller-near-locations>
</p-dialog>

